<template>
  <tr class="approve__shareclass mds-data-table__row">
    <td class="mds-data-table__cell">
      <div v-if="isPending" class="pending-icon mds-icon">
        <svg class="mds-icon" aria-hidden="true">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="static/mds/icons/mds.svg#clock-back"
          ></use>
        </svg>
      </div>
    </td>
    <td class="mds-data-table__cell" scope="row">
      <slot></slot>
    </td>
    <td class="mds-data-table__cell">
      {{ ticker }}
    </td>
    <td class="mds-data-table__cell mds-data-table__cell--left">
      <div v-if="selected">
        <status-icons :status="statusArray" />
        {{ statusText }}
      </div>
      <div v-else>
        <status-icons v-if="newStatus" :status="[{ name: newStatusIcon }]" />
        <status-icons v-else :status="statusArray" />
        <div class="mds-form__select">
          <select class="mds-form__select-input  approve-class-select-status" :value="newStatus" @change="onSelectStatus">
            <option
              v-for="option in options"
              class="mds-form__select-option"
              :value="option.value"
              :disabled="option.config.disabled"
              :key="option.value"
            >
              {{ option.label }}
            </option>
          </select>
          <div class="mds-form__select-visual-wrap"></div>
          <span class="mds-form__select-open-indicator">
            <svg class="mds-icon mds-form__select-open-icon" aria-hidden="true">
              <use xlink:href="static/mds/icons/mds.svg#caret-down--s"></use>
            </svg>
          </span>
        </div>
      </div>
    </td>
    <td class="mds-data-table__cell mds-data-table__cell--left">
      <div v-if="selected">
        {{ categoryText }}
      </div>
      <div v-else>
        <div class="mds-form__select">
          <select
            class="mds-form__select-input approve-class-select-categories"
            :value="newCategory"
            @change="onSelectCategory"
          >
            <option v-if="!morningstarCategoryFound" value="0">
              Select
            </option>
            <optgroup label="Morningstar, Inc. Category">
              <option
                class="mds-form__select-option"
                :value="morningstarCategory.id"
                :disabled="!morningstarCategoryFound"
              >
                {{ morningstarCategory.name }}
              </option>
            </optgroup>
            <optgroup label="Fiduciary Category">
              <option
                v-for="category in categories"
                class="mds-form__select-option"
                :value="category.id"
                :key="category.id"
              >
                {{ category.name }}
              </option>
            </optgroup>
          </select>
          <div class="mds-form__select-visual-wrap"></div>
          <span class="mds-form__select-open-indicator">
            <svg class="mds-icon mds-form__select-open-icon" aria-hidden="true">
              <use xlink:href="static/mds/icons/mds.svg#caret-down--s"></use>
            </svg>
          </span>
        </div>
      </div>
    </td>
  </tr>
</template>
<script>
import StatusIcons from '@/components/atoms/StatusIcons';

export default {
  name: 'approve-shareclass',
  components: {
    StatusIcons,
  },
  props: {
    selected: {
      type: Boolean,
      default: true,
    },
    statusArray: {
      type: Array,
      required: true,
    },
    statusText: {
      type: String,
      default: '',
    },
    ticker: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    newStatus: {
      type: Number,
      default: 0,
    },
    newStatusIcon: {
      type: String,
      default: '',
    },
    newStatusText: {
      type: String,
      default: '',
    },
    categories: {
      type: Array,
      default() {
        return [];
      },
    },
    morningstarCategory: {
      type: Object,
      default() {
        return {
          id: 0,
          name: '',
          found: undefined,
        };
      },
    },
    categoryText: {
      type: String,
      default: '',
    },
    newCategory: {
      type: Number,
      default: 0,
    },
    isPending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    morningstarCategoryFound() {
      return this.morningstarCategory.found !== undefined;
    },
  },
  methods: {
    onSelectStatus(event) {
      this.$emit('onSelectStatus', parseInt(event.target.value, 10));
    },
    onSelectCategory(event) {
      this.$emit('onSelectCategory', parseInt(event.target.value, 10));
    },
  },
};
</script>
<style lang="scss">
.approve__shareclass {
  & div[class^="status-array"] {
    display: inline;
  }
  & .status-icons {
    margin-right: $mds-space-half-x;
  }
  & .mds-form__select {
    margin-top: -$mds-space-1-x;
    max-width: 100%;
  }
}
</style>
